export default "__VITE_ASSET__l20P7eBv__"